/**
 * Mobile Status Banners - Free Agent Search
 * Shows status messages (transactions disabled, errors, success)
 */

import React from 'react';
import { AlertCircle, CheckCircle, Info } from 'lucide-react';
import { dynastyTheme } from '../../../../services/colorService';

const C = dynastyTheme.tokens.colors;

const MobileStatusBanners = ({ state, isCommissionerMode, activeTeamName }) => {
  const {
    error,
    successMessage,
    transactionsEnabled,
    browseMode,
    noPricesWarning,
    handleBrowseAnyway
  } = state;

  return (
    <>
      {/* Error Message — 9o.6.d-followup: role=alert + aria-live=assertive for screen readers */}
      {error && (
        <div
          role="alert"
          aria-live="assertive"
          style={{
          padding: '12px',
          backgroundColor: `${dynastyTheme.tokens.colors.error}20`,
          border: `1px solid ${dynastyTheme.tokens.colors.error}`,
          borderRadius: '8px',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'start',
          gap: '8px'
        }}>
          <AlertCircle size={18} style={{ color: dynastyTheme.tokens.colors.error, flexShrink: 0, marginTop: '1px' }} />
          <div>
            <p style={{
              color: dynastyTheme.tokens.colors.error,
              fontSize: '12px',
              fontWeight: '600',
              margin: '0 0 4px 0'
            }}>
              Error
            </p>
            <p style={{
              color: dynastyTheme.tokens.colors.error,
              fontSize: '11px',
              margin: 0,
              opacity: 0.9
            }}>
              {error}
            </p>
          </div>
        </div>
      )}

      {/* Success Message — 9o.6.d-followup: role=status + aria-live=polite for screen readers */}
      {successMessage && (
        <div
          role="status"
          aria-live="polite"
          style={{
          padding: '12px',
          backgroundColor: `${dynastyTheme.tokens.colors.success}20`,
          border: `1px solid ${dynastyTheme.tokens.colors.success}`,
          borderRadius: '8px',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'start',
          gap: '8px'
        }}>
          <CheckCircle size={18} style={{ color: dynastyTheme.tokens.colors.success, flexShrink: 0, marginTop: '1px' }} />
          <div>
            <p style={{
              color: dynastyTheme.tokens.colors.success,
              fontSize: '12px',
              fontWeight: '600',
              margin: '0 0 4px 0'
            }}>
              Success
            </p>
            <p style={{
              color: dynastyTheme.tokens.colors.success,
              fontSize: '11px',
              margin: 0,
              opacity: 0.9
            }}>
              {successMessage}
            </p>
          </div>
        </div>
      )}

      {/* No Prices Warning (when transactions not enabled) */}
      {!transactionsEnabled && !browseMode && noPricesWarning && (
        <div style={{
          padding: '16px',
          backgroundColor: dynastyTheme.tokens.colors.neutral[800],
          border: `1px solid ${dynastyTheme.tokens.colors.warning}`,
          borderRadius: '8px',
          marginBottom: '12px',
          textAlign: 'center'
        }}>
          <Info size={32} style={{ color: dynastyTheme.tokens.colors.warning, marginBottom: '12px' }} />
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: C.white,
            marginBottom: '8px'
          }}>
            Transactions Not Yet Available
          </h3>
          <p style={{
            fontSize: '12px',
            color: dynastyTheme.tokens.colors.neutral[400],
            marginBottom: '16px',
            lineHeight: '1.5'
          }}>
            The commissioner must set player prices before transactions can begin.
          </p>
          <button
            onClick={handleBrowseAnyway}
            style={{
              padding: '10px 20px',
              backgroundColor: dynastyTheme.tokens.colors.neutral[700],
              color: C.white,
              border: `1px solid ${dynastyTheme.tokens.colors.neutral[600]}`,
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Browse Players (View Only)
          </button>
        </div>
      )}

      {/* Browse Mode Indicator */}
      {browseMode && !transactionsEnabled && (
        <div style={{
          padding: '10px 12px',
          backgroundColor: `${dynastyTheme.tokens.colors.warning}20`,
          border: `1px solid ${dynastyTheme.tokens.colors.warning}`,
          borderRadius: '8px',
          marginBottom: '12px',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '11px',
            color: dynastyTheme.tokens.colors.warning,
            margin: 0,
            fontWeight: '600'
          }}>
            VIEW ONLY MODE - Transactions disabled until prices are set
          </p>
        </div>
      )}

      {/* Commissioner Mode Indicator */}
      {isCommissionerMode && activeTeamName && (
        <div style={{
          padding: '10px 12px',
          backgroundColor: `${dynastyTheme.tokens.colors.primary}20`,
          border: `1px solid ${dynastyTheme.tokens.colors.primary}`,
          borderRadius: '8px',
          marginBottom: '12px',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '11px',
            color: dynastyTheme.tokens.colors.primary,
            margin: 0,
            fontWeight: '600'
          }}>
            Adding players to: {activeTeamName}
          </p>
        </div>
      )}
    </>
  );
};

export default MobileStatusBanners;
